import React from "react";
import { Icon } from "@tvg/design-system/web";
import type { IconProps } from "@tvg/design-system/web/components/Icon/types";
import { buildQaLabel } from "@tvg/test-utils/utils";
import { NavigationItem } from "../../types";
import BalanceItem from "../BalanceItem";
import { BadgeWrapper } from "./styled-components";
import { BADGE, ICON, ITEM } from "../../constants";

export const renderIcon = (
  item: NavigationItem,
  color: string,
  qaLabel: string = ""
) => {
  if (item.showBalance) {
    return (
      <BalanceItem textColor={color} qaLabel={buildQaLabel([qaLabel, ITEM])} />
    );
  }

  const iconProps: IconProps = {
    size: "m",
    name: item.iconName ?? "error",
    lineColor: color,
    qaLabel: buildQaLabel([qaLabel, ITEM, ICON, item.iconName ?? "error"])
  };

  if (item.counter) {
    return (
      <BadgeWrapper
        counter={item.counter}
        qaLabel={buildQaLabel([qaLabel, ITEM, ICON, BADGE])}
      >
        <Icon {...iconProps} />
      </BadgeWrapper>
    );
  }

  return <Icon {...iconProps} />;
};
